export const getRecItemUrl = (recItem) => {
  if(
    !recItem
    || typeof recItem !== "object"
    || recItem.id === undefined
  ) return undefined;

  return `/recordings/${recItem.id}`;
};
